import { render, staticRenderFns } from "./MessagePopUp.vue?vue&type=template&id=91caf462&scoped=true&"
import script from "./MessagePopUp.vue?vue&type=script&lang=js&"
export * from "./MessagePopUp.vue?vue&type=script&lang=js&"
import style0 from "./MessagePopUp.vue?vue&type=style&index=0&id=91caf462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91caf462",
  null
  
)

export default component.exports